<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    width="1200px"
    :title="title"
    show-close
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :payeeScmCode="payeeScmCode"
      :payeeCustCode="payeeCustCode"
      @radio-change="onRadioChange"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="confirm()"
        :disabled="notCheck"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    payeeScmCode: { type: String, default: () => '' },
    payeeCustCode: { type: String, default: () => '' },
  },
  data() {
    return {
      checkedRow: null,
    }
  },
  computed: {
    notCheck() {
      return !this.checkedRow || this.checkedRow === {}
    },
  },
  methods: {
    onRadioChange({ newValue }) {
      this.checkedRow = newValue
    },
    confirm() {
      if (this.notCheck) return
      this.$emit('confirm', this.checkedRow)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
